import { useEffect, useState } from "react";
import axios from "axios";
import { ChatState } from "../../Context/ChatProvider";
import "./style.css";
import { useToast } from "@chakra-ui/react";
import LevelTable from "./Table/levelTable";
import Level_crud from "./level/levelForm";



function Levels() {
	const [fetchAgain, setFetchAgain] = useState(false);
	const toast = useToast();
	const [obj, setObj] = useState([]);
	const [search, setSearch] = useState("");
	const [loading, setLoading] = useState(false);

	const {
		user,
	} = ChatState();

	useEffect(() => {
		if(fetchAgain===true || user!=undefined)
		getAllLevels();
		
	}, [fetchAgain,user]);


	async function getAllLevels() {
			try {
				setObj([])
				setLoading(true);
				const config = {
					headers: {
						Authorization: `Bearer ${user.token}`,
					},
				};
				const { data } = await axios.get(`/api/level`, config)

				setLoading(false);
				
				setObj(data)

			} catch (error) {
				toast({
					title: "Une erreur s'est produite !",
					description: "Échec du chargement des résultats de recherche",
					status: "error",
					duration: 5000,
					isClosable: true,
					position: "bottom-left",
				});
			}
			setFetchAgain(false);
		};


 

	return (
		<div className=" w-full  flex flex-col">
			<div className="">
				<div className="head ">
				    <input className="h-6 w-64 lg:w-80 md:w-80 mr-3 py-4 px-2 rounded-md border xs:w-20"
					 type="text" placeholder="Recherche..."  
					 onChange={(e)=>setSearch(e.target.value) } />
					<Level_crud  setFetchAgain={setFetchAgain} />
				</div>
				<div className="">
					  <div className="table_container"> 
						<LevelTable data={obj} search={search} loading={loading} setFetchAgain={setFetchAgain}/>
						
					</div>
				</div>
			</div>
		</div>
	);
}

export default Levels;
